import React, { Component } from 'react';
import { Page } from './components/affichage/Page';

export default class App extends Component {
    obtenirVariablesGlobales() {
        return [
        ];
    }

    render() {
        const chemin = window.location.pathname;
        if (!chemin.includes('/InformationsComplementaires')) {
            window.location.pathname = '/InformationsComplementaires';
        }
        return <Page />;
    }
}

